export default __webpack_public_path__ + "static/media/circle-03.5b14df92.png";